import styled, { CSSProperties } from "styled-components";
import { ReactComponent as LimePhone } from "../../images/LimeGreenPhone.svg"
import { ReactComponent as LimeEnvelope} from "../../images/LimeGreenEnvelope.svg";
import { t } from "i18next";

const bannerStyle: CSSProperties = {
  backgroundColor: "var(--dark_blue)",
  margin: "0px",
  whiteSpace: "pre",
  width: "100%",
  maxWidth: "100%",
  textWrap: "wrap",
};

const DualContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

const linkContainerDiv: CSSProperties = {
  textAlign: "center",
  width: "100%"
};

const StyledLink = styled.a`
  font-family: Comfortaa;
  color: var(--lime_green);
  font-weight: bold;
  letter-spacing: -3%;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  text-wrap: wrap;
  margin: 0 2em;
  
  /* Responsive font size using media queries */
  font-size: 1rem; /* Mobile default */
  
  @media (min-width: 768px) { /* Tablet size */
    font-size: 2.2rem;
  }
}
`;

const bottomDivStyle: CSSProperties = {
  display: "block",
  padding: "15px",
  whiteSpace: "pre",
  width: "100%",
  maxWidth: "100%",
  textWrap: "wrap",
  textAlign: "center",
  color: "var(--light_purple)",
  fontFamily: "Comfortaa",
  fontWeight: "bold",
  fontSize: "18",
  letterSpacing: "-3%",
  alignItems: "center",
};

type BhasoBannerProps = {
  Visible: boolean;
  Bhasos: string[];
};

export default function BhasoBanner({ Visible, Bhasos }: BhasoBannerProps) {

  return Visible && Bhasos ? (
    <div style={bannerStyle}>
      <div >
        <p style={{ padding: "15px", color: "var(--pale_green)", fontWeight: "bold", textAlign: "center", lineHeight: "normal", fontFamily: "Comfortaa" }}>
          {t("plsContactBhasos") + " " + Bhasos.join(" or ") }.
        </p>
      </div>
      <DualContainerDiv as="div">
        {Bhasos.includes("Signal Behavioral Health Network") ?
        <div style={linkContainerDiv}>
          <StyledLink
            as="a"
            target="_blank "
            href={`tel:${'8886074462'}`}
          >
          <LimePhone />
          <span>(888) 607-4462</span>
          </StyledLink>
          <StyledLink
            as="a"
            target="_blank "
            href={`mailto:${'findcare@signalbhn.org'}`}
          >            
            <LimeEnvelope />
            <span>findcare@signalbhn.org</span>
          </StyledLink>
        </div> : <></>}
        {Bhasos.includes("Rocky Mountain Health Plans") ? 
        <div style={linkContainerDiv}>
          <StyledLink
            as="a"
            target="_blank "
            href={`tel:${'8558301562'}`}
          >
          <LimePhone />
          <span>(855) 830-1562</span>
          </StyledLink>
          <StyledLink
            as="a"
            target="_blank "
            href={`mailto:${'rmhp.bhaso@uhc.com'}`}
          >            
            <LimeEnvelope/>
            <span>rmhp.bhaso@uhc.com</span>
          </StyledLink>
        </div> : <></>}
      </DualContainerDiv>
      <div style={bottomDivStyle}>
        {t("availM-F")}
      </div>
    </div>
  ) : (
    <></>
  );
}
